module.exports = __webpack_public_path__ + "img/funDeatilNewDataTwo.2c655440.png";